import graphql__7015bb1f82e4fb0acaf0 from "./__generated__/AnswerPresentationTitle_answer.graphql.js";import { graphql, useFragment } from "react-relay";

const AnswerPresentationTitle = props => {
  const { formField } = useFragment(AnswerPresentationTitle_answer, props.answer);
  const { label } = formField;

  return (
    <h2 className="form-presentation-title text-subtitle-page margin-bottom-sm">
      {label}
    </h2>
  );
};

const AnswerPresentationTitle_answer = graphql__7015bb1f82e4fb0acaf0;

export default AnswerPresentationTitle;
